import ApiClient from './api';

/**
 * General API service for various API operations
 */
class ApiService {
  constructor() {
    this.api = new ApiClient();
  }

  /**
   * Initiate a demo call
   * @param {string} customerId - Customer ID
   * @param {Object} callData - Call data { phone, meeting_type }
   * @returns {Promise<Object>} Call initiation result with call_id
   */
  async initiateDemoCall(customerId, callData) {
    try {
      const response = await this.api.post(`/api/v1/demo/call/${customerId}`, callData);
      return response;
    } catch (error) {
      console.error('Error initiating demo call:', error);
      throw error;
    }
  }

  /**
   * Get demo call status
   * @param {string} customerId - Customer ID
   * @param {string} callId - Call ID from initiateDemoCall
   * @returns {Promise<Object>} Call status with dynamic_variables
   */
  async getDemoCallStatus(customerId, callId) {
    try {
      const response = await this.api.get(`/api/v1/demo/call/${customerId}/${callId}/status`);
      return response;
    } catch (error) {
      console.error('Error getting demo call status:', error);
      throw error;
    }
  }

  /**
   * Stop an active demo call
   * @param {string} customerId - Customer ID
   * @param {string} callId - Call ID to stop
   * @returns {Promise<Object>} Stop call result
   */
  async stopDemoCall(customerId, callId) {
    try {
      const response = await this.api.post(`/api/v1/demo/call/${customerId}/${callId}/stop`, {});
      return response;
    } catch (error) {
      console.error('Error stopping demo call:', error);
      throw error;
    }
  }
}

export const apiService = new ApiService();
export default ApiService;
